(function () {
  'use strict';

  function initCountdown(el) {
    var endDate = el.dataset.end;
    if (!endDate) return;

    var end = new Date(endDate).getTime();
    if (isNaN(end)) {
      el.hidden = true;
      return;
    }

    var daysEl = el.querySelector('[data-countdown-days]');
    var hoursEl = el.querySelector('[data-countdown-hours]');
    var minsEl = el.querySelector('[data-countdown-mins]');

    function tick() {
      var now = Date.now();
      var diff = end - now;
      if (diff <= 0) {
        el.hidden = true;
        return;
      }
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      if (daysEl) daysEl.textContent = String(days);
      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minsEl) minsEl.textContent = String(mins).padStart(2, '0');
    }

    tick();
    setInterval(tick, 60000);
  }

  function renderStars(el) {
    if (!el || el.dataset.rendered === 'true') return;
    var rating = parseFloat(el.dataset.rating || '0');
    if (isNaN(rating) || rating <= 0) return;
    var full = Math.max(0, Math.min(5, Math.round(rating)));
    var stars = el.querySelector('.staradio-buybox__stars');
    if (stars) {
      stars.textContent = '★★★★★'.slice(0, full) + '☆☆☆☆☆'.slice(0, 5 - full);
    }
    el.dataset.rendered = 'true';
  }

  function deferRatings(root) {
    var nodes = root.querySelectorAll('[data-staradio-defer-rating]');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(renderStars);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            renderStars(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '80px 0px' }
    );

    nodes.forEach(function (node) {
      io.observe(node);
    });
  }

  function bindScrollToAtc(root) {
    root.querySelectorAll('[data-staradio-scroll-to-atc]').forEach(function (btn) {
      if (btn.dataset.bound === 'true') return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', function (event) {
        var atc = document.querySelector(
          '.buy-buttons-block, [data-block-type="buy-buttons"], product-form-component, .product-form'
        );
        if (!atc) return;
        event.preventDefault();
        atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  function initDeferredMedia(root) {
    root.querySelectorAll('[data-staradio-defer-media]').forEach(function (wrap) {
      if (wrap.dataset.loaded === 'true') return;
      if (!('IntersectionObserver' in window)) {
        wrap.dataset.loaded = 'true';
        return;
      }
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var tpl = wrap.querySelector('template');
            if (tpl) {
              wrap.appendChild(tpl.content.cloneNode(true));
              tpl.remove();
            }
            wrap.dataset.loaded = 'true';
            io.disconnect();
          });
        },
        { rootMargin: '200px 0px' }
      );
      io.observe(wrap);
    });
  }

  function hideDuplicatePdpTitle() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('.product-details h1').forEach(function (heading) {
      var block = heading.closest('.shopify-block');
      var parent = block && block.parentElement;
      if (parent && parent.classList.contains('group-block-content')) {
        block.style.display = 'none';
        return;
      }
      var text = heading.closest('.text-block');
      if (text) {
        text.style.display = 'none';
        return;
      }
      heading.style.display = 'none';
    });
  }

  function bindMarquee(root) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    var scope = root.querySelectorAll ? root : document;
    var viewports = [];
    if (root.matches && root.matches('[data-staradio-marquee]')) viewports.push(root);
    if (scope.querySelectorAll) {
      scope.querySelectorAll('[data-staradio-marquee]').forEach(function (node) {
        viewports.push(node);
      });
    }
    viewports.forEach(function (viewport) {
      var mobileOnly = viewport.getAttribute('data-staradio-marquee') === 'mobile';
      var track =
        viewport.querySelector('.staradio-trust-bar__track, .staradio-pdp-assurance__list') ||
        viewport.firstElementChild;
      if (!track || track.children.length === 0) return;

      // Desktop / editor: remove mobile marquee clones so the grid does not double up.
      if (mobileOnly && !isMobile) {
        track.querySelectorAll('.staradio-marquee-clone').forEach(function (clone) {
          clone.remove();
        });
        delete track.dataset.cloned;
        return;
      }

      if (track.dataset.cloned === 'true') return;
      track.dataset.cloned = 'true';
      Array.prototype.slice.call(track.children).forEach(function (child) {
        if (child.classList.contains('staradio-marquee-clone')) return;
        var clone = child.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.classList.add('staradio-marquee-clone');
        clone.removeAttribute('data-shopify-editor-block');
        track.appendChild(clone);
      });
    });
  }

  function bindMega(root) {
    var nav = document.querySelector('.staradio-mega');
    if (!nav || nav.dataset.bound === 'true') return;
    nav.dataset.bound = 'true';

    function closeAll() {
      nav.querySelectorAll('[data-mega-trigger]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
        var panel = btn.parentElement && btn.parentElement.querySelector('.staradio-mega__panel');
        if (panel) panel.hidden = true;
      });
    }

    nav.querySelectorAll('[data-mega-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-mega-item]');
        var panel = item && item.querySelector('.staradio-mega__panel');
        var open = btn.getAttribute('aria-expanded') === 'true';
        closeAll();
        if (!open && panel) {
          btn.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('.staradio-mega')) closeAll();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll();
    });
  }

  function bindSavings(root) {
    root.querySelectorAll('[data-staradio-savings]').forEach(function (section) {
      if (section.dataset.bound === 'true') return;
      section.dataset.bound = 'true';
      var miles = section.querySelector('[data-savings-miles]');
      var days = section.querySelector('[data-savings-days]');
      var gas = section.querySelector('[data-savings-gas]');
      var mpg = section.querySelector('[data-savings-mpg]');
      var yearEl = section.querySelector('[data-savings-year]');
      var monthEl = section.querySelector('[data-savings-month]');
      var gallonsEl = section.querySelector('[data-savings-gallons]');
      var wearEl = section.querySelector('[data-savings-wear]');

      function money(value) {
        return '$' + Math.max(0, value).toFixed(0);
      }

      function calc() {
        var weeklyMiles = (parseFloat(miles && miles.value) || 0) * (parseFloat(days && days.value) || 0);
        var mpgVal = parseFloat(mpg && mpg.value) || 1;
        var gallonsWeek = weeklyMiles / mpgVal;
        var fuelWeek = gallonsWeek * (parseFloat(gas && gas.value) || 0);
        var wearWeek = weeklyMiles * 0.15;
        var month = (fuelWeek + wearWeek) * 4.345;
        if (yearEl) yearEl.textContent = money(month * 12);
        if (monthEl) monthEl.textContent = money(month);
        if (gallonsEl) gallonsEl.textContent = (gallonsWeek * 4.345).toFixed(1) + ' gal';
        if (wearEl) wearEl.textContent = money(wearWeek * 4.345);
      }

      section.addEventListener('input', calc);
      calc();
    });
  }

  function bindPdpTabs() {
    if (window.__staradioPdpTabsBound) return;
    window.__staradioPdpTabsBound = true;
    document.documentElement.dataset.staradioPdpTabsBound = 'true';

    function hashFromHref(href) {
      if (!href) return '';
      var index = String(href).indexOf('#');
      return index === -1 ? '' : String(href).slice(index);
    }

    function isDocumentScroller(el) {
      return el === document.documentElement || el === document.body || el === document.scrollingElement;
    }

    function getScroller() {
      var wrapper = document.querySelector('.page-wrapper');
      if (wrapper) {
        var overflowY = window.getComputedStyle(wrapper).overflowY;
        if (overflowY === 'auto' || overflowY === 'scroll') return wrapper;
      }
      return document.scrollingElement || document.documentElement;
    }

    function offsetTop() {
      var header = document.getElementById('header-component') || document.querySelector('header-component');
      var headerH = header ? header.getBoundingClientRect().height : 0;
      var bar = document.querySelector('.staradio-pdp-tabs-bar');
      var tabsH = bar ? bar.getBoundingClientRect().height : 0;
      return headerH + tabsH + 8;
    }

    function panelFromHash(hash) {
      var id = hashFromHref(hash);
      if (!id || id.length < 2) return null;
      try {
        id = decodeURIComponent(id.slice(1));
      } catch (error) {
        id = id.slice(1);
      }
      return document.getElementById(id);
    }

    function scrollToPanel(target) {
      if (!target) return false;
      var extra = offsetTop();
      var scroller = getScroller();
      var nextTop;
      if (isDocumentScroller(scroller)) {
        nextTop = (window.pageYOffset || scroller.scrollTop || 0) + target.getBoundingClientRect().top - extra;
        window.scrollTo({ top: Math.max(0, nextTop), behavior: 'smooth' });
        if (scroller.scrollTo) scroller.scrollTo({ top: Math.max(0, nextTop), behavior: 'smooth' });
      } else {
        nextTop = scroller.scrollTop + target.getBoundingClientRect().top - scroller.getBoundingClientRect().top - extra;
        scroller.scrollTo({ top: Math.max(0, nextTop), behavior: 'smooth' });
      }
      return true;
    }

    function setActive() {
      var links = document.querySelectorAll('[data-staradio-tab-link]');
      if (!links.length) return;
      var activeId = '';
      var marker = offsetTop() + 8;
      links.forEach(function (link) {
        var target = panelFromHash(link.getAttribute('href') || link.href);
        if (!target) return;
        var rect = target.getBoundingClientRect();
        if (rect.top <= marker && rect.bottom > marker) activeId = hashFromHref(link.getAttribute('href') || link.href);
      });
      if (!activeId && links[0]) activeId = hashFromHref(links[0].getAttribute('href') || links[0].href);
      links.forEach(function (link) {
        link.classList.toggle('is-active', hashFromHref(link.getAttribute('href') || link.href) === activeId);
      });
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('[data-staradio-tab-link]');
      if (!link) return;
      var target = panelFromHash(link.getAttribute('href') || link.href);
      if (!target) return;
      event.preventDefault();
      scrollToPanel(target);
      document.querySelectorAll('[data-staradio-tab-link]').forEach(function (item) {
        item.classList.toggle('is-active', item === link);
      });
    });

    if (!document.documentElement.classList.contains('shopify-design-mode') && window.location.hash) {
      scrollToPanel(panelFromHash(window.location.hash));
    }
    setActive();
    var scroller = getScroller();
    if (scroller && !isDocumentScroller(scroller)) scroller.addEventListener('scroll', setActive, { passive: true });
    window.addEventListener('scroll', setActive, { passive: true });
  }

  function bindFeatureTrack(root) {
    var scope = root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-staradio-feature-track]').forEach(function (track) {
      if (track.dataset.bound === 'true') return;
      track.dataset.bound = 'true';
      var panel = track.closest('.staradio-pdp-catalog__panel');
      var prev = panel && panel.querySelector('[data-staradio-feature-prev]');
      var next = panel && panel.querySelector('[data-staradio-feature-next]');
      function scrollByDir(dir) {
        var amount = Math.max(track.clientWidth * 0.85, 240);
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { scrollByDir(-1); });
      if (next) next.addEventListener('click', function () { scrollByDir(1); });
    });
  }

  function initSection(root) {
    bindPdpTabs();
    root.querySelectorAll('[data-staradio-countdown]').forEach(initCountdown);
    deferRatings(root);
    bindScrollToAtc(root);
    initDeferredMedia(root);
    bindMega(root);
    bindMarquee(root);
    hideDuplicatePdpTitle();
    bindSavings(root);
    bindFeatureTrack(root);
  }

  function onSectionLoad(event) {
    var section = event.target;
    if (section && section.querySelector) initSection(section);
  }

  document.addEventListener('shopify:section:load', onSectionLoad);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSection(document);
    });
  } else {
    initSection(document);
  }

  if (window.matchMedia) {
    window.matchMedia('(max-width: 749px)').addEventListener('change', function () {
      initSection(document);
    });
  }
})();
